// extracted by mini-css-extract-plugin
module.exports = {"className":"my-MM_className__vQqFB"};